'use client'
import { createContext } from 'react'
import { type FeatureFlags } from '@/features/shared/services/FeatureFlags/types'
import { type QueryStatus } from '@tanstack/react-query'

export type FeatureFlagsContextType = {
  flags: FeatureFlags
  status: QueryStatus
}

export const FeatureFlagsContext = createContext<FeatureFlagsContextType | null>(null)
